import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Button from "./Button";

const Hero = () => {
  return (
    <section
      className="relative min-h-screen pt-24 sm:pt-32 pb-12 sm:pb-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: "url(/estabild_hero.jpeg)",
      }}
    >
      {/* Enhanced gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/75 to-black/95" />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/20 via-transparent to-primary-900/20" />

      {/* Content */}
      <div className="relative container-custom flex items-end min-h-[calc(100vh-6rem)] sm:min-h-[calc(100vh-8rem)]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-5xl pb-8 sm:pb-16"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-heading font-bold text-white mb-4 sm:mb-6 leading-tight tracking-tight drop-shadow-2xl">
            Intelligent reporting for real estate development projects
          </h1>
          <p className="text-base sm:text-lg lg:text-xl font-body font-normal text-white/95 mb-8 sm:mb-10 leading-relaxed max-w-4xl drop-shadow-lg">
            With Estabild you can easily prepare reports for your real estate
            projects and share them with investors and lenders. We gather and
            automate all important project data for reporting, so you can stay
            focused on what matters the most.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
            <Link to="/contact">
              <Button
                variant="primary"
                size="large"
                className="w-full sm:w-auto shadow-primary-glow-lg hover:shadow-primary-glow-lg"
              >
                Book demo
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
